import { UUID } from 'crypto';

export enum ControlModeAuthority {
  SCADA,
  HMI,
  CALENDAR,
}

export enum ControlModeTemplateFieldsType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  SELECT = 'select',
}

export interface IControlModeTemplateSettings {
  controllerField: string;
  uiLabel: string;
  fields: (
    | IStringInputFieldControlModeTemplate
    | INumberInputFieldControlModeTemplate
    | IBooleanInputFieldControlModeTemplate
    | ISelectInputFieldControlModeTemplate
  )[];
}

// main
export interface IControlModeTemplate {
  id: UUID;
  name: string;
  settings: IControlModeTemplateSettings[];
  deleted: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export interface IControlModeTemplateFieldsRange {
  min?: number;
  max?: number;
}

export interface IStringInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.STRING;
  quickConfig: boolean;
}

export interface IStringInputFieldControlModeTemplate
  extends IStringInputFieldBase {
  defaultValue?: string;
}

export interface INumberInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.NUMBER;
  range?: IControlModeTemplateFieldsRange;
  quickConfig: boolean;
}

export interface INumberInputFieldControlModeTemplate
  extends INumberInputFieldBase {
  defaultValue?: number;
}

export interface IBooleanInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.BOOLEAN;
  quickConfig: boolean;
}

export interface IBooleanInputFieldControlModeTemplate
  extends IBooleanInputFieldBase {
  defaultValue?: boolean;
}

export interface ISelectInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.SELECT;
  listOptions: string[];
  quickConfig: boolean;
}

export interface ISelectInputFieldControlModeTemplate
  extends ISelectInputFieldBase {
  defaultValue?: string;
}

export interface IControlModeTemplateFields {
  uiLabel: string;
  controllerField: string;
  type: string;
  range?: IControlModeTemplateFieldsRange;
  listOptions?: string[];
  defaultValue?: string | number | boolean;
  quickConfig: boolean;
}
